import React, { useState } from 'react';
import css from '../calculatorStyles.module.css';

const ResultDisplay = ({ valueEur, newPriceEur, retentionPct, notes, adjustments }) => {
  const [showBreakdown, setShowBreakdown] = useState(false);

  const adjEntries = Object.entries(adjustments || {});

  return (
    <div className={css.results}>
      <div className={css.tile}>
        <span className={css.tileTitle}>Estimated Value</span>
        <div className={css.tileRight}>
          <span className={css.tileValue}>{Math.round(valueEur)} EUR</span>
        </div>
      </div>
      <div className={css.tile}>
        <span className={css.tileTitle}>New Price Reference</span>
        <div className={css.tileRight}>
          <span className={css.tileMeta}>{Math.round(newPriceEur)} EUR</span>
        </div>
      </div>
      <div className={css.tile}>
        <span className={css.tileTitle}>Value Retention</span>
        <div className={css.tileRight}>
          <span className={css.tileMeta}>{retentionPct}%</span>
        </div>
      </div>
      {adjEntries.length > 0 && (
        <details className={css.details}>
          <summary>Show calculation breakdown</summary>
          <table className={css.referenceTable}>
            <thead>
              <tr>
                <th>Factor</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {adjEntries.map(([key, val]) => (
                <tr key={key}>
                  <td>{key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase())}</td>
                  <td>{typeof val === 'number' ? (val < 2 ? `${(val * 100).toFixed(1)}%` : `${Math.round(val)} EUR`) : val}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </details>
      )}
      {notes && notes.length > 0 && (
        <div className={css.note}>
          {notes.map((n, i) => <p key={i}>{n}</p>)}
        </div>
      )}
    </div>
  );
};

export default ResultDisplay;
